import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../Buttons/Button";
import { changeIpoStatus } from "../../store/actions/ipos/changeIpoStatus";
import { ipoSettableStatusOptions } from "../../config/data";

const statusHints = {
  upcoming: "The offer shows a date instead of a Subscribe button.",
  open: "Investors can subscribe.",
  closed: "Subscriptions stop. Required before allotment can be applied.",
  allotment:
    "Marks the offer as with the registrar. Every open subscription moves to \"processing\".",
  cancelled:
    "Cancels the offer. Refund subscriptions individually from the subscribers table.",
};

function ChangeIpoStatusModal({ open, onClose, ipo }) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.ipos?.statusPending);
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (open) {
      setStatus("");
    }
  }, [open]);

  const options = ipoSettableStatusOptions.filter(
    (opt) => opt.value !== ipo?.status
  );

  const handleSubmit = () => {
    dispatch(changeIpoStatus({ id: ipo?.id, status, callback: onClose }));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          maxWidth: "95vw",
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ position: "absolute", top: 19, right: 10 }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-3">
          <h1 className="font-semibold text-2xl mb-1">Change Offer Status</h1>
          <p className="text-sm mb-6 text-[#475467]">
            Currently{" "}
            <span className="font-[600] capitalize">{ipo?.status || "-"}</span>.
            Pick the status to move this offer to.
          </p>

          <div className="flex flex-col gap-2 mb-6">
            {options.map((opt) => (
              <label
                key={opt.value}
                className={`flex items-start gap-3 border rounded-lg p-3 cursor-pointer ${
                  status === opt.value
                    ? "border-[#159AA8] bg-[#F0FAFB]"
                    : "border-[#EAECF0]"
                }`}
              >
                <input
                  type="radio"
                  name="ipo-status"
                  value={opt.value}
                  checked={status === opt.value}
                  onChange={() => setStatus(opt.value)}
                  className="mt-1 accent-[#159AA8]"
                />
                <span>
                  <span className="block text-sm font-[600]">{opt.label}</span>
                  <span className="block text-xs text-[#475467]">
                    {statusHints[opt.value]}
                  </span>
                </span>
              </label>
            ))}
          </div>

          <div className="flex mt-2 w-full items-center">
            <CustomButton
              variant="outlined"
              customColor="#fff"
              children="Cancel"
              width="100%"
              height="44px"
              borderColor="#D0D5DD"
              color="#344054"
              margin="0px 25px 0px 0px"
              onClick={onClose}
            />
            <CustomButton
              variant="contained"
              customColor={status === "cancelled" ? "#B42318" : "#159AA8"}
              children="Update Status"
              width="100%"
              height="44px"
              loading={loading}
              padding="10px"
              color="#fff"
              disabled={!status || loading}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ChangeIpoStatusModal;
